const baseURL = "https://emsup21.herokuapp.com/";
// const baseURL = "http://localhost:8090/";

export default baseURL;
